import React from 'react';
import { motion } from 'framer-motion';
// تأكد أن مسار الصورة صحيح كما كان عندك
import logo from '../../assets/images/logo.png'; 

const TransitionLoader = ({ fullScreen = false, height = "300px" }) => {
  
  // تحديد الستايل ديناميكياً
  const containerStyle = fullScreen 
    ? {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        backgroundColor: 'var(--background-color)', // يستخدم خلفية الموقع
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }
    : {
        width: '100%',
        height: height, // ارتفاع مرن حسب القسم
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'transparent',
      };

  return (
    <motion.div
      style={containerStyle}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.img
        src={logo}
        alt="Loading..."
        style={{ 
          // تكبير اللوجو قليلاً إذا كان في وضع ملء الشاشة
          width: fullScreen ? '120px' : '80px', 
          height: 'auto',
          objectFit: 'contain'
        }}
        // أنيميشن التنفس (Breathing Animation) الخاص بك
        animate={{ 
          scale: [0.9, 1.1, 0.9], 
          opacity: [0.7, 1, 0.7] 
        }}
        transition={{
          duration: 1.5,
          ease: "easeInOut",
          repeat: Infinity,
        }}
      />
    </motion.div>
  );
};

export default TransitionLoader;